import React from "react";

import { Text, Icon } from "@ui-component-library";

import { usePlusBlockerDialog } from "@components/PlusBlockerDialog/PlusBlockerDialog.context";
import { useMetricData } from "../hooks/UseMetricData";
import { formatNumber } from "../../utils";
import { SubscriptionCoverRow } from "../components/SubscriptionCovers";

const labels = [
  {
    label: "Totalvolym",
    suffix: "m³sk",
  },
  {
    label: "Fastighetsvärde",
    suffix: "kr",
  },
  {
    label: "Virkesförråd medeltal",
    suffix: "m³sk/ha",
  },
  {
    label: "Medelbonitet",
    suffix: "m³sk/ha/år",
  },
  {
    label: "Tillväxt",
    suffix: "m³sk/år",
  },
  {
    label: "Värdetillväxt",
    suffix: "kr/år",
  },

  {
    label: "Årlig tillväxt",
    suffix: "%",
  },
];

export default function KeyDataWidget() {
  const { openPlusBlockerDialog } = usePlusBlockerDialog();
  const {
    totalVolume,
    avgGrowth,
    totalGrowth,
    avgStockPerHa,
    totalPropValue,
    totalArbonics,
    yearlyGrowth,
    propDfr,
  } = useMetricData();
  const totalValue = totalPropValue.totalValue;

  const computedData = labels.map((item) => {
    const averagePricePerM3 = totalVolume > 0 ? totalValue / totalVolume : 0;
    const valueGrowth = Math.ceil(averagePricePerM3 * totalGrowth);

    const value = () => {
      switch (item.label) {
        case "Fastighetsvärde":
          return formatNumber(Math.ceil(totalValue / 10000) * 10000);
        case "Totalvolym":
          return formatNumber(totalVolume);
        case "Medelbonitet":
          return formatNumber(avgGrowth.toFixed(1) ?? avgGrowth);
        case "Virkesförråd medeltal":
          return formatNumber(avgStockPerHa);
        case "Tillväxt":
          return formatNumber(totalGrowth);
        case "Värdetillväxt":
          return formatNumber(valueGrowth);
        case "Årlig tillväxt":
          return Math.round(yearlyGrowth);
        default:
          return item.value;
      }
    };

    return {
      ...item,
      value: value(),
    };
  });

  

  const shouldBlur = (label) =>
    !propDfr &&
    [
      "Fastighetsvärde",
      "Värdetillväxt",
      "Medelbonitet",
      "Tillväxt",
      "Årlig tillväxt",
    ].includes(label);

  return (
    <div className="grid grid-cols-2 gap-2 p-2">
      {computedData.map((item, i) => (
        <div
          key={i}
          className="bg-[#F5F5F5] p-3 rounded-lg-alt gap-1-5 max-w-[220px]"
        >
          <Text
            variant="text-xs/leading-normal/normal"
            className="text-[#737373] truncate"
            as="p"
            title={item.label}
          >
            {item.label}
          </Text>
          <SubscriptionCoverRow
            shouldBlur={shouldBlur(item.label)}
            onClick={() => openPlusBlockerDialog("property-value")}
            className="flex flex-row items-center flex-wrap justify-between gap-0-5"
          >
            <Text variant="text-sm/leading-normal/medium" as="p">
              {item?.value || "-"}
            </Text>
            <Text variant="text-xs/leading-none/normal" as="p">
              {item.suffix}
            </Text>
          </SubscriptionCoverRow>
        </div>
      ))}
      <div className="bg-[#F5F5F5] p-3 rounded-lg-alt gap-1-5 max-w-[220px]">
        <Text
          variant="text-xs/leading-normal/normal"
          className="text-[#737373] truncate"
          as="p"
          title="Kolkrediter"
        >
          Potential kolkrediter
        </Text>
        <div className="flex flex-row flex-wrap items-baseline gap-1">
          <div className="flex flex-row items-baseline gap-1">
            <Text variant="text-sm/leading-normal/medium" as="p">
            {totalArbonics?.eligible == 2 ? (propDfr ? `${formatNumber(totalArbonics.price)} kr` : "Ja") : "Nej"}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
